import { ReactNode } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { SearchableListbox } from '@frontend/design-system';

interface SearchableListboxMenuProps<T> {
  data: T[];
  renderItem: (item: T) => ReactNode;
  keyGen: (item: T) => string;
  getItemValue: (item: T) => string;
  value: string;
  onSelect: (value: string | string[]) => void;
  getSearchValue: (item: T) => string;
}

export const PersonSearchableListbox = <T,>({
  data,
  renderItem,
  keyGen,
  getItemValue,
  onSelect,
  value,
  getSearchValue,
}: SearchableListboxMenuProps<T>) => {
  return (
    <SearchableListbox css={listboxStyle} labelId='searchable-listbox' onSelect={onSelect} value={value}>
      {data.map((item) => (
        <SearchableListbox.Option
          key={keyGen(item)}
          value={getItemValue(item)}
          css={optionStyle}
          searchValue={getSearchValue(item)}
        >
          {renderItem(item)}
        </SearchableListbox.Option>
      ))}
    </SearchableListbox>
  );
};

const listboxStyle = css`
  height: 240px;
`;

const optionStyle = css`
  border-radius: ${theme.borderRadius.small};
  padding: ${theme.spacing(1)};

  span {
    display: flex;
    gap: ${theme.spacing(1)};
    align-items: center;
  }
`;
